import { SettingsState } from '../types';

export enum ActionType {
  SET_SETTINGS = 'SETTINGS/SET_SETTINGS',
}

export interface SetSettings {
  type: ActionType.SET_SETTINGS;
  payload: Partial<SettingsState>;
}

export const setSettings = (payload: Partial<SettingsState>): SetSettings => ({
  type: ActionType.SET_SETTINGS,
  payload,
});
